import { useState } from 'react';

const useDateRange = () => {
  const [fromdate, setFromDate] = useState(new Date());
  const [todate, setToDate] = useState(new Date());

  return {
    fromdate,
    todate,
    setFromDate,
    setToDate,
  };
};

export default useDateRange;
